import type { TFunction } from 'i18next'

import { CURRICULUM_TIME_UNITS } from '../constants/curriculum-time-unit'

export const getCurriculumTimeUnitOptions = (
  t: TFunction<'curriculumsManagement'>
) =>
  CURRICULUM_TIME_UNITS.map(type => ({
    label: t(`time-unit.${type}`),
    value: type
  }))
